import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { history } from "./helpers/history";
import { logout } from "./actions/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { clearMessage } from "./actions/message";
import Login from './components/Login/Login'
import ForgotPassword from './components/Login/ForgotPassword'
import UserManagement from "./components/Users/UserManagement"
import AgenciesManagement from "./components/Agency/AgenciesManagement"
import CentersManagement from "./components/Center/CentersManagement"
import Profile from "./components/Profile"
import Booking from "./components/Booking/Booking";
import BookingsManagement from "./components/Booking/BookingsManagement";
import NavBar_v2 from "./components/NavBar_v2/NavBar_v2";
import BookingsDetails from "./components/Booking/BookingDetails/BookingDetails";
import SlideRoutes from 'react-slide-routes';
import CreateAccount from "./components/Login/CreateAccount";

const App = () => {
  return (
    <>
      <NavBar_v2 />
      <Router >
        <div>

          <Route exact path="/" element={<Login />} />
          <Route path="/Booking" element={<Booking />} />
          <Route path="/bookings-management" element={<BookingsManagement />} />
          <Route path='bookings-management/:booking_id' element={<BookingsDetails />} />
          <Route path="/users-management" element={<UserManagement />} />
          <Route path="/agencies-management" element={<AgenciesManagement />} />
          <Route path="/centers-management" element={<CentersManagement />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/create-account" element={<CreateAccount />} />
        </div>

      </Router>
    </>)
}


export default App;